<template>
  <div v-show="isOpen">
    <h4>
      Actie instellingen
      <a-button type="link" @click="isOpen = false">Terug</a-button>
    </h4>
    <a-form-model ref="ruleForm" :model="form" :rules="getRules">
      <a-form-model-item v-for="setting in settings" :label="setting.description" :key="setting.name"
                         :prop="setting.name">
        <a-input v-model="form[setting.name]" v-if="setting.type === 'string'"
                 @change="clearError(setting.name)"></a-input>

        <a-input-number required v-model="form[setting.name]" :min="setting.options.min" :max="setting.options.max"
                        v-else-if="setting.type === 'integer'" @change="clearError(setting.name)"></a-input-number>

        <a-input-number v-model="form[setting.name]" :min="setting.options.min" :max="setting.options.max"
                        v-else-if="setting.type === 'float'" @change="clearError(setting.name)"></a-input-number>

        <date-picker-component v-model="form[setting.name]" v-else-if="setting.type === 'date'"
                             @change="clearError(setting.name)"/>

        <a-time-picker value-format="H:mm" v-model="form[setting.name]" v-else-if="setting.type === 'time'"
                       format="H:mm" @change="clearError(setting.name)"></a-time-picker>

        <a-radio-group v-model="form[setting.name]" v-else-if="setting.type === 'boolean'"
                       @change="clearError(setting.name)">
          <a-radio :value="true">
            Ja
          </a-radio>
          <a-radio :value="false">
            Nee
          </a-radio>
        </a-radio-group>

        <a-input v-model="form[setting.name]" v-else-if="setting.type === 'phonenumber'"
                 @change="clearError(setting.name)"></a-input>

        <a-checkbox-group v-model="form[setting.name]" v-else-if="setting.type === 'checkbox'"
                          :options="setting.list" @change="clearError(setting.name)"></a-checkbox-group>

        <a-select v-model="form[setting.name]" v-else-if="setting.type === 'select'" placeholder="Maak een keuze..."
                  style="min-width: 200px;" @change="clearError(setting.name)">
          <a-select-option v-for="item in setting.list" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>

        <span v-else>Er is iets fout gegaan. De instelling '{{ setting.name }}' heeft geen beschikbaar type.</span>

        <small v-for="message in errors[setting.name]" class="validation-error">{{ message }}</small>
      </a-form-model-item>
      <a-divider/>
      <a-form-model-item>
        <a-button type="primary" @click="act">Start actie</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import DatePickerComponent from "../../components/DatePickerComponent";

export default {
  props: {
    open: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    settings: {
      type: Array,
      required: false
    },
    errors: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      form: {},
      // Make sure that the 'required' object comes first in the array.
      // This object is possibly deleted if from the backend the field is not set to required.
      rules: {
        string: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'blur'}
        ],
        integer: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'blur'}
        ],
        float: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'blur'}
        ],
        date: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'change'}
        ],
        time: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'change'}
        ],
        boolean: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'change'}
        ],
        phonenumber: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'blur'},
          {
            validator: (rule, value) => {
              let regex = /^\(?([+]31|0031|0)-?6(\s?|-)([0-9]\s{0,3}){8}$/;
              return !value || regex.test(value);
            }
            ,
            message: 'Vul een geldig telefoonnummer in (geen spaties; beginnend met 06, +316 of 00316)',
            trigger: 'blur'
          }
        ],
        checkbox: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'change'}
        ],
        select: [
          {required: true, message: 'Dit veld is verplicht', trigger: 'change'}
        ],
      }
    }
  },
  components: {
    DatePickerComponent
  },
  methods: {
    act() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$emit("act", { value: this.form });
          if (this.errors.length === 0) {
            this.isOpen = false;
          }
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.form = {};
    },
    clearError(name) {
      if (this.errors && this.errors[name]) {
        this.$delete(this.errors, name);
      }
    },
    clearAllErrors() {
      Object.entries(this.errors).forEach(error => {
        const [key] = error;
        this.clearError(key);
      })
    }
  },
  watch: {
    open: function (newValue) {
      if (newValue === false) {
        this.clearForm();
        this.clearAllErrors();
      }
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(open) {
        this.$emit('open', open);
      }
    },
    getRules() {
      if (!this.settings) return null;

      let rulesObject = {};

      this.settings.forEach((object) => {
        rulesObject[object.name] = this.rules[object.type];

        if (!object.required) {
          rulesObject[object.name].shift()
        }
      })

      return rulesObject;
    }
  }
}
</script>

<style scoped>
.validation-error {
  font-style: italic;
  color: red;
  display: block;
  text-align: right;
}
</style>
